import React from 'react';
import { Question, Answer } from '../../gds-api-client';
import AnswerTextbox from './Textbox';
import { AnswerDropdown } from './Dropdown';

type EmptyAnswer = { questionId: string; text: null } | { questionId: string; optionId: null };

interface EditAnswerFieldProps {
  name: string;
  questions: Question[];
  answers: Answer[];
  addNew: (emptyAnswer: EmptyAnswer) => void;
}

const EditAnswerField: React.FC<EditAnswerFieldProps> = props => {
  const { questions, answers, addNew, name } = props;

  // create empty answers as placeholders to render form fields
  React.useEffect(() => {
    if (questions.length > answers.length) {
      questions.forEach(q => {
        if (q.id) {
          const aIndex = answers.findIndex(a => a.questionId === q.id);
          if (aIndex === -1) {
            if (q.answerType === 'Text') {
              addNew({ questionId: q.id, text: null });
            } else if (q.answerType === 'Option') {
              addNew({ questionId: q.id, optionId: null });
            }
          }
        }
      });
    }
  }, [addNew, answers, questions]);

  return (
    <div>
      {questions.map(q => {
        const answerIndex = answers.findIndex(a => a.questionId === q.id);
        if (answerIndex > -1) {
          switch (q.answerType) {
            case 'Text':
              return <AnswerTextbox key={q.id} name={`${name}[${answerIndex}].text`} placeholder={q?.text || ''} />;
            case 'Option':
              return (
                <AnswerDropdown
                  key={q.id}
                  name={`${name}[${answerIndex}].optionId`}
                  options={q.options || null}
                  placeholder={q?.text}
                />
              );
            default:
              break;
          }
        }
        return null;
      })}
    </div>
  );
};

export default EditAnswerField;
